export default __webpack_public_path__ + "static/media/darkLight.3130e460.png";